import { ListDisplayMode } from '@/enums';
import { useLayoutContext } from '@/contexts/layout-context';
import { useMemo } from 'react';
import { useUserSettingsContext } from '@/contexts/user-context';

interface Options {
  enableOnSmallLayouts?: boolean;
}

export const useShowListView = ({
  enableOnSmallLayouts = false,
}: Options = {}) => {
  const { largeItemListDisplayMode } = useUserSettingsContext();
  const { isSmallLayout, isSmallTabletLayout } = useLayoutContext();

  return useMemo(() => {
    const showListViewToggle = !isSmallTabletLayout && !isSmallLayout;
    const canShowListView = enableOnSmallLayouts || showListViewToggle;
    return {
      showListView:
        canShowListView && largeItemListDisplayMode === ListDisplayMode.List,
      showListViewToggle,
    };
  }, [
    enableOnSmallLayouts,
    isSmallLayout,
    isSmallTabletLayout,
    largeItemListDisplayMode,
  ]);
};
